import { useState, useEffect, useCallback } from 'react';

export const useToast = (autoClose = 5000) => {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, type = 'info') => {
    const id = Date.now().toString();
    setToasts((prev) => [...prev, { id, message, type }]);
    
    if (autoClose > 0) {
      setTimeout(() => {
        removeToast(id);
      }, autoClose);
    }
    
    return id;
  }, [autoClose]);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  }, []);

  return { toasts, addToast, removeToast };
};



// WEBPACK FOOTER //
// ./src/design-system/molecules/Toast/hooks/useToast.js